import { render, staticRenderFns } from "./BespokeReports.vue?vue&type=template&id=4e7c4acd&"
import script from "./BespokeReports.vue?vue&type=script&lang=js&"
export * from "./BespokeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports